import { observer } from 'mobx-react-lite'
import { TableRow } from '@/components/Table'
import { type ScopeChangeRequestDetailsViewModel } from '@/features/admin/scope-change-requests/components/ScopeChangeRequestDetailsPanel/ScopeChangeRequestDetailsViewModel'
import { type ScopeChangePriceBreakDownItemForAdmin } from '@/features/admin/scope-change-requests/ScopeChangeRequest'
import { QuantityCell } from '@/features/admin/scope-change-requests/components/ScopeChangeRequestDetailsPanel/ItemsSection/components/QuantityCell'
import { ServiceCell } from '@/features/admin/scope-change-requests/components/ScopeChangeRequestDetailsPanel/ItemsSection/components/ServiceCell'
import { MoneyCellContainer } from '@/features/admin/scope-change-requests/components/ScopeChangeRequestDetailsPanel/ItemsSection/components/MoneyCell/MoneyCellContainer'
import { ItemsBreakdownSection } from '@/features/admin/scope-change-requests/components/ScopeChangeRequestDetailsPanel/ItemsSection/ItemsBreakdownSection'

export interface BundlesSectionContainerProps {
  vm: ScopeChangeRequestDetailsViewModel
}

export const BundlesSectionContainer = observer(
  function BundlesSectionContainer({ vm }: BundlesSectionContainerProps) {
    return (
      <ItemsBreakdownSection
        title="Bundles"
        itemColumnTitle="Bundle"
        isExpanded={vm.bundlesExpanded}
        onToggleExpanded={vm.toggleBundlesSection}
        count={
          vm.scopeChangeRequestPriceBreakDown.bundleScopeChangeItems.length
        }
      >
        {vm.scopeChangeRequestPriceBreakDown.bundleScopeChangeItems.map(
          (item) => (
            <BundleRowContainer item={item} key={item.bundleId} />
          ),
        )}
      </ItemsBreakdownSection>
    )
  },
)

interface BundleRowContainerProps {
  item: ScopeChangePriceBreakDownItemForAdmin
}

const BundleRowContainer = observer(function BundleRowContainer({
  item,
}: BundleRowContainerProps) {
  return (
    <TableRow>
      <QuantityCell>{item.quantityDiff}</QuantityCell>
      <ServiceCell>{item.displayName}</ServiceCell>
      <MoneyCellContainer
        editable={false}
        model={item}
        testId="scope-change-request-bundle-price"
        field="priceDiff"
      >
        {item.priceDiff}
      </MoneyCellContainer>
      <MoneyCellContainer
        editable={false}
        model={item}
        testId="scope-change-request-bundle-pro-price"
        field="proPriceDiff"
      >
        {item.proPriceDiff}
      </MoneyCellContainer>
    </TableRow>
  )
})
